import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SummaryField from './SummaryField';
import { countrySpecificTranslationParser } from '../selectors/utils';

const YesNoFieldSummary = ({
  booleanAnswer,
  country,
  hideContent = false,
  titleYesKey,
  titleNoKey,
  yesAnswer,
  t,
  ...rest
}) => {
  if (hideContent) {
    return null;
  }
  return booleanAnswer ? (
    <SummaryField title={t(titleYesKey)} content={yesAnswer} {...rest} />
  ) : (
    <SummaryField title={t(titleNoKey)} content={t(`products-fe.general.no`)} {...rest} />
  );
};

YesNoFieldSummary.propTypes = {
  booleanAnswer: PropTypes.bool.isRequired,
  country: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  titleNoKey: PropTypes.string.isRequired,
  titleYesKey: PropTypes.string.isRequired,
  hideContent: PropTypes.bool,
  yesAnswer: PropTypes.string,
};

export default connect((state, { country }) => ({
  t: tKey => countrySpecificTranslationParser(state)(tKey, country),
}))(YesNoFieldSummary);
